import React, { useEffect, useState } from "react";
import ProductCard from "@/components/ProductCard";
import { getRecent } from "@/lib/recentlyViewed";

export default function RecentlyViewed({ excludeId, title = "Recently Viewed", subtitle = "Pick up where you left off 🐾", className = "" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getRecent().filter((p) => p.id !== excludeId).slice(0, 4));
  }, [excludeId]);

  if (items.length === 0) return null;

  return (
    <section className={`max-w-7xl mx-auto px-4 sm:px-6 ${className}`} data-testid="recently-viewed-section">
      <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-[#19324A] mb-1">{title}</h2>
      <p className="text-[#19324A]/60 mb-6 text-sm">{subtitle}</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {items.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
